import { Interface } from '@ethersproject/abi'
import { ChainId, STAKING_ABI } from '../constants'
import { CurrencyValue } from '../model'
import { getStakingAddress, StakingOption } from '../pages/token/staking/utils'
import { StakingWithdrawInfo } from '../providers/transactions/model'

export function getStakingWithdrawTransaction(
  chainId: ChainId,
  account: string,
  stakingOption: StakingOption,
  withdrawValue: CurrencyValue
) {
  const stakingAddress = getStakingAddress(stakingOption, chainId)
  const txInfo = {
    type: 'WITHDRAW_STAKE',
    stakingOption,
    value: withdrawValue.format(),
  } as StakingWithdrawInfo

  return {
    to: stakingAddress,
    data: new Interface(STAKING_ABI).encodeFunctionData('withdrawAll', [account]),
    txInfo,
  }
}
